<template>
    <!-- BEGIN Notifications Table-->
    <div class="container-fluid notifications-table">
        <div class="search-results m-t-20">
            <div class="row">
                <div class="col-md-12">
                    <div class="panel panel-transparent">
                        <div class="panel-body">
                            <ul class="nav nav-tabs nav-tabs-simple">
                                <li :class="isActionsTab ? 'active' : ''">
                                    <a @click="changeTab('action')" data-toggle="tab" href="#">Actions</a>
                                </li>
                                <li :class="!isActionsTab ? 'active' : ''">
                                    <a @click="changeTab('information')" data-toggle="tab" href="#">Informations</a>
                                </li>
                            </ul>

                            <ul class="form__group__wrapper" v-if="isActionsTab">
                                <li>
                                    <custom-select :field="fields[0]" :value="fields[0].value" :field_idx="0" @field-updated="updateDefaultParams($event, 'read')"></custom-select>
                                </li>
                            </ul>

                            <div class="notifications-table" v-if="notificationsList.length > 0">
                                <pagination v-if="paginationNeeded"
                                            :current-page="currentPage"
                                            :total-pages="totalPages"
                                            @click="getPageOnClick($event)">
                                </pagination>

                                <div class="table-responsive">
                                    <table class="table table-hover table-condensed table-detailed search-table" id="detailedTable">
                                        <thead>
                                            <tr>
                                                <th class="notification-date__column">Date</th>
                                                <th class="notification-hour__column">Heure</th>
                                                <th class="notification-category__column">Catégorie</th>
                                                <th class="notification-message__column">Message</th>
                                                <th v-if="isActionsTab" class="notification-read__column">Traitée</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="notification in notificationsList" :key="'list-' + notification.id">
                                                <td>{{ notification.created_at | dateFormat }}</td>
                                                <td class="notification-hour__column">{{ notification.created_at | hourFormat }}</td>
                                                <td class="notification-category__column">
                                                    <div class="notification__category">{{ notification.decoded_type }}</div>
                                                </td>
                                                <td class="notification-message__column">
                                                    <a v-if="notification.data.has_link" :href="notificationLink(notification)">{{ notification.message }}</a>
                                                    <span v-else>{{ notification.message }}</span>
                                                </td>
                                                <td v-if="isActionsTab">
                                                    <div :id="'checkbox-' + notification.id"
                                                        class="checkbox check-primary checkbox-circle"
                                                        title="marquer comme traitée"
                                                        v-if="!updatingNotificationId"
                                                    >
                                                        <input @click="manageToggleReadAttribute(notification)" type="checkbox" :checked="notification.read_at != null ? 'checked' : ''" value="1" :id="'list-' + notification.id">
                                                        <label :for="'list-' + notification.id"></label>
                                                    </div>
                                                    <div :id="'loader-' + notification.id"
                                                        class="notification__loader"
                                                        v-else-if="updatingNotificationId == notification.id"
                                                    >
                                                        <div class="spinner--round"></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <pagination v-if="paginationNeeded"
                                            :current-page="currentPage"
                                            :total-pages="totalPages"
                                            @click="getPageOnClick($event)">
                                </pagination>
                            </div>

                            <div class="alert alert-info m-t-20" v-else>
                                Aucune notification
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- END Notifications Table !-->
</template>

<style lang="scss" scoped>
tbody tr td a {
  display: block;
}
.notification__category {
  display: inline-block;
  background: #eb7593;
  margin: 5px 0;
  padding: 3px 10px;
  color: #fff;
  font-size: 12px;
}
.customers-table {
    padding: 0;
}
.panel-body {
    min-width: 600px;
    padding: 0;
}
.form__group__wrapper {
    display: flex;
    margin-top: 10px;
}
.form__group__item {
    display: inline-block;
    .form-group {
        min-width: 100px;
    }
    .form__group__item--type {
        min-width: 200px;
    }
}
.notification-read__column {
    width: 100px;
}
.notification-date__column {
    width: 100px;
}
.notification-hour__column {
    width: 80px;
    text-align: center;
}
.notification-category__column {
    width: 150px;
    text-align: center;
}
.notification-message__column {
    width: 100%;
}
.checkbox {
    text-align: center;
    margin-top: 0px;
    margin-bottom: 0px;
    label {
        padding-left: 18px !important;
        margin-right: 0;
        &::after {
            left: 1px;
        }
    }
}
.notification__loader {
    width: 17px;
    height: 21px;
    margin: 10px auto;
    padding-top: 2px;
}
.spinner--round {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    border-width: 1px;
    border-style: solid;
    border-color: #ccc;
    border-top-color: #fb557a;
    border-left-color: #fb557a;
    animation: basic 1s infinite linear;
}
@keyframes basic {
    0%   { transform: rotate(0); }
    100% { transform: rotate(359.9deg); }
}
</style>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Pagination from 'components/Pagination'
import CustomSelect from 'components/Forms/Elements/Select'

export default {
    name: 'notificationsList',

    data () {
        return {
            fields: [
                {
                    values: [
                        {'id': null, 'text': 'Toutes'},
                        {'id': 1, 'text': 'Traitées'},
                        {'id': 0, 'text': 'Non traitées'}
                    ],
                    multiple: false,
                    placeholder: 'Toutes',
                    disabled: false,
                    idx: 0,
                    required: false,
                    value: null,
                    label: "Notifications traitées",
                    type: "select"
                }
            ],
            updatingNotificationId: null
        }
    },

    components: {
        Pagination,
        CustomSelect
    },

    created () {
        this.updateTypeGroupForView(this.$route.query.type)
    },

    async mounted () {
        await this.getLoggedUser().then(() => this.fetchViewNotifications())
    },

    methods: {
        ...mapActions(['getLoggedUser']),
        ...mapActions('notifications', [
            'fetchViewNotifications',
            'updateTypeGroupForView',
            'updatePageForView',
            'updateReadForView',
            'toggleReadAttribute',
            'readNotification',
            'fetchHeaderActionNotifications',
            'fetchHeaderInfoNotifications'
        ]),

        changeTab (notificationTypeGroup) {
            this.updateTypeGroupForView(notificationTypeGroup)
            this.fetchViewNotifications()
        },

        getPageOnClick (event) {
            this.updatePageForView(event + 1)
            this.fetchViewNotifications()
        },

        updateDefaultParams (event, target) {
            switch (target) {
                case 'read':
                    this.fields[0].value = event.new_value

                    const readValue = _.isNil(event.new_value) ? null : event.new_value.value

                    this.updateReadForView(readValue)

                    break
            }

            this.updatePageForView(1)
            this.fetchViewNotifications()
        },

        notificationLink (notification) {
            return window.location.origin + '/' + notification.link
        },

        manageToggleReadAttribute(notification) {
            this.updatingNotificationId = notification.id

            this.toggleReadAttribute(notification).then(response => {
                this.fetchViewNotifications()

                if ('action' == notification.type_group) {
                    this.fetchHeaderActionNotifications().then(() => this.updatingNotificationId = null)
                } else if ('information' == notification.type_group) {
                    this.fetchHeaderInfoNotifications().then(() => this.updatingNotificationId = null)
                }
            })
        }
    },

    computed: {
        ...mapGetters('notifications', [
            'viewNotifications',
            'viewRequestParams'
        ]),

        isActionsTab() {
            return this.viewRequestParams.type_group === 'action'
        },
        currentPage() {
            return this.viewNotifications.current_page - 1
        },
        totalPages() {
            return this.viewNotifications.last_page
        },
        paginationNeeded() {
            return this.viewNotifications.last_page > 1
        },
        notificationsList() {
            return this.viewNotifications.data
        }
    },

    filters: {
        dateFormat(date) {
            return moment(date).format('DD/MM/YYYY')
        },

        hourFormat(date) {
            return moment(date).format('HH:mm')
        }
    },

    watch:{
        $route(to, from){
            this.changeTab(this.$route.query.type)
        }
    },

    updated() {
        if (this.viewRequestParams.type_group === 'information' && this.notificationsList.length > 0) {
            _.forEach(this.notificationsList, (notification) => {
                if (notification.read_at === null && notification.type_group === 'information') {
                    this.readNotification(notification)
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// client/components/Notifications/NotificationsList.vue